import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'minhaatorizacao' : '123456789'
  })
};

export class Imovel {
  situacao: string;
  tipo: string;
  endereco: string;
  bairro: string;
  cidade: string;
  valor: number;
  condominio: number;
  iptu: number;
  area: number;
  garagem: number;
  quartos: number;
  banheiros: number;
  descricao: string;
  img_lista: string;
  maps?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  // apiUrl = '/api/veiculos/';
  apiUrl = 'http://www.vanguardacondominios.com.br/imobiliaria/api/imoveis/';

  listImovel: Imovel[] = [];

  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http.get(this.apiUrl + 'getall.php');
  }

  getById(id): Observable<any> {
    return this.http.get(this.apiUrl + 'getbyid.php?id=' + id);
  }

  sendmessage(data: object): Observable<any> {
    Object.assign(data, {});
    console.log('datamessage:', data);
    return this.http.post(this.apiUrl + 'sendmessage.php', data, httpOptions);
  }
}
